import { render, staticRenderFns } from "./scHistorial.vue?vue&type=template&id=fd80c876&scoped=true"
import script from "./scHistorial.vue?vue&type=script&lang=js"
export * from "./scHistorial.vue?vue&type=script&lang=js"
import style0 from "./scHistorial.vue?vue&type=style&index=0&id=fd80c876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd80c876",
  null
  
)

export default component.exports